import type { z } from "@hono/zod-openapi";
import { tmsEventKind } from "../base";
import { stopEventRefs } from "../subjects/stopEvent/refs";
import { callRejectionFacts, callRejectionV2Facts } from "../subjects/stopEvent/callRejectionFacts";

/**
 * The TMS refused the call because the trailer it named does not match what the TMS has the truck hooked to.
 */
export const trailerMismatchV1 = tmsEventKind(
  { category: "callRejection", kind: "trailerMismatch", version: 1 },
  { refs: stopEventRefs, facts: callRejectionFacts },
);

export const TrailerMismatchV1Schema = trailerMismatchV1.schema;
export const TrailerMismatchV1FactsSchema = trailerMismatchV1.facts;

export type TrailerMismatchV1 = z.infer<typeof TrailerMismatchV1Schema>;
export type TrailerMismatchV1Facts = z.infer<typeof TrailerMismatchV1FactsSchema>;

/**
 * Version 2: the same refusal, plus what the driver's call said — its type, load, trailers, consignee, and lines.
 */
export const trailerMismatchV2 = tmsEventKind(
  { category: "callRejection", kind: "trailerMismatch", version: 2 },
  { refs: stopEventRefs, facts: callRejectionV2Facts },
);

export const TrailerMismatchV2Schema = trailerMismatchV2.schema;
export const TrailerMismatchV2FactsSchema = trailerMismatchV2.facts;

export type TrailerMismatchV2 = z.infer<typeof TrailerMismatchV2Schema>;
export type TrailerMismatchV2Facts = z.infer<typeof TrailerMismatchV2FactsSchema>;

/** Every version of `trailerMismatch`, keyed by version. What `catalog.ts` places under `callRejection`. */
export const trailerMismatch = { 1: trailerMismatchV1, 2: trailerMismatchV2 } as const;
